import React, { useEffect, useState } from "react";

import {
  Breadcrumb,
  Button,
  Input,
  message,
  PageHeader,
  Select,
  Form,
  Row,
  Col,
  Popconfirm,
  Checkbox,
  Drawer,
  Table,
  InputNumber,
  Space,
  Spin,
} from "antd";

import { Link } from "react-router-dom";
import Page from "_components/Page";
import TabMenu from "./TabMenu";
import { materialTypeService } from "_services";

function Transactions({ match, history }) {
  const { id } = match.params;
  const { path } = match;

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoading(true);
    materialTypeService
      .getTransactions(id)
      .then((x) => {
        setItems(x.content);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setError(error);
      });
  }, []);

  const getLineColumns = () => {
    let columns = [];

    columns.push({
      title: "Transaction Date",
      dataIndex: "transactionDate",
      key: "transactionDate",
      width: "20%",
      render: (text, record) => {
        if (record) {
          return `${record?.transactionDate}`;
        }
      },
    });

    columns.push({
      title: "Transaction Type",
      dataIndex: "transaction.type",
      key: "Transaction Type",
      width: "20%",
      render: (text, record) => {
        if (record) {
          return `${record?.transactionType?.transaction}`;
        }
      },
    });

    columns.push({
      title: "Quantity",
      dataIndex: "quantityValue",
      key: "Quantity",
      width: "20%",
      render: (text, record) => {
        if (record) {
          return `${record?.quantityValue ?? ""}`;
        }
      },
    });
    columns.push({
      title: "Username",
      dataIndex: "user.username",
      key: "Username",
      width: "20%",
      render: (text, record) => {
        if (record) {
          return `${record?.user?.firstName}  ${record?.user?.lastName} `;
        }
      },
    });

    columns.push({
      title: "Reference",
      dataIndex: "reference",
      key: "reference",
      width: "20%",
      render: (text, record) => {
        if (record) {
          return `${record?.reference ?? ""}`;
        }
      },
    });

    return columns;
  };

  return (
    <PageHeader
      title={
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/dashboard">Dashboard</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/bom/boms/">BOM</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`${path}`}> Transactions </Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      }
      //Add buttons in the page header
      // extra={getActionButtons()}
    >
      <Page inner>
        <Spin tip="Loading..." spinning={loading}>
          <TabMenu menu="transactions" id={id} />

          {items && (
            <Table
              bordered
              pagination={false}
              columns={getLineColumns()}
              dataSource={items}
              size="small"
            />
          )}
        </Spin>
      </Page>
    </PageHeader>
  );
}

export default Transactions;
